var HTTP_PROTOCOL = "https://";
export var WEBAPP_WEBSITE_SERVER_ADDRESS = "www.remotepc.com";
export var WEBAPP_WEBSITE_DOMAIN = "".concat(HTTP_PROTOCOL, "www.remotepc.com");
export var WEBAPP_RDP_WEBSITE_DOMAIN = "".concat(HTTP_PROTOCOL, "www.remotepc.com");
export var WEBAPP_APP_DOMAIN = "".concat(HTTP_PROTOCOL, "app.remotepc.com");
export var WEBAPP_LOGIN_DOMAIN = "".concat(HTTP_PROTOCOL, "login.remotepc.com");
export var WEBAPP_UI_ASSEST_STATIC_DOMAIN = "".concat(HTTP_PROTOCOL, "static.remotepc.com");
export var WEBAPP_RPC_STATIC_WEBSITE_DOMAIN = "".concat(HTTP_PROTOCOL, "www.remotepc.com");
export var WEBAPP_SSO_WEBSITE_DOMAIN = "".concat(HTTP_PROTOCOL, "sso.remotepc.com");
export var WEBAPP_DOWNLOAD_DOMAIN = "".concat(HTTP_PROTOCOL, "download.remotepc.com");
export var WEBAPP_REMOTE_DESKTOP_WEBSITE_SERVER_ADDRESS = "www.remotedesktop.com";
export var WEBAPP_REMOTE_DESKTOP_WEBSITE_DOMAIN = "".concat(HTTP_PROTOCOL).concat(WEBAPP_REMOTE_DESKTOP_WEBSITE_SERVER_ADDRESS);
export var WEBAPP_REMOTE_DESKTOP_APP_DOMAIN = "".concat(HTTP_PROTOCOL, "web.remotedesktop.com");
export var WEBAPP_REMOTE_DESKTOP_HELP_STATIC_LINK = "".concat(HTTP_PROTOCOL, "remotedesktop.com");
export var WEBAPP_REMOTE_DESKTOP_LOGIN_DOMAIN = "".concat(HTTP_PROTOCOL, "login.remotedesktop.com");
export var WEBAPP_REMOTE_DESKTOP_SSO_WEBSITE_DOMAIN = "".concat(HTTP_PROTOCOL, "sso.remotedesktop.com");
export var WEBAPP_REMOTE_DESKTOP_DOWNLOAD_DOMAIN = "".concat(HTTP_PROTOCOL, "download.remotedesktop.com");
export var WEBAPP_REMOTE_DESKTOP_UI_ASSEST_STATIC_DOMAIN = "".concat(HTTP_PROTOCOL, "static.remotedesktop.com");
export var REMOTEDESKTOP_PRODUCT_CODE = "rdp";
export var REMOTEPC_PRODUCT_CODE = "rpc";
export var MEETING_PRODUCT_CODE = "meeting";
export var RPC_MIRROR_PRODUCTCODE = "mirror";
export var IS_WEBVIEWER = "webviewer";
export var IS_ATTENDEDACCESS = "attendedAccess";
var RPC_MEETING_DOMAINS = {
    website: WEBAPP_WEBSITE_DOMAIN,
    app: WEBAPP_APP_DOMAIN,
    login: WEBAPP_LOGIN_DOMAIN,
    static: WEBAPP_UI_ASSEST_STATIC_DOMAIN,
    sso: WEBAPP_SSO_WEBSITE_DOMAIN,
    download: WEBAPP_DOWNLOAD_DOMAIN
};
export var DOMAIN_MAP = {
    rpc: RPC_MEETING_DOMAINS,
    meeting: RPC_MEETING_DOMAINS,
    rdp: {
        website: WEBAPP_REMOTE_DESKTOP_WEBSITE_DOMAIN,
        app: WEBAPP_REMOTE_DESKTOP_APP_DOMAIN,
        login: WEBAPP_REMOTE_DESKTOP_LOGIN_DOMAIN,
        static: WEBAPP_REMOTE_DESKTOP_UI_ASSEST_STATIC_DOMAIN,
        sso: WEBAPP_REMOTE_DESKTOP_SSO_WEBSITE_DOMAIN,
        download: WEBAPP_REMOTE_DESKTOP_DOWNLOAD_DOMAIN
    },
};
// GST and VAT constants
export var DEFAULT_GST_COUNTRIES = Object.freeze(["INDIA", "CANADA"]);
export var DEFAULT_GST_COUNTRY_SET = new Set(DEFAULT_GST_COUNTRIES);
export var isGSTCountry = function (country, gstCountries) {
    var countries = gstCountries || DEFAULT_GST_COUNTRY_SET;
    return countries.has((country || "").trim().toUpperCase());
};
export var GST_COUNTRY = "INDIA";
export var INVALID_VATID_ERROR = "Enter a valid VAT ID";
export var INVALID_GSTIN_ERROR = "Enter a valid GSTIN";
export var VAT_BLOCK_HEADER = "Business VAT ID";
export var VAT_BLOCK_BODY = "You have selected a billing country where RemotePC products and services are taxable. If your company is registered for VAT, you may not have to pay Value Added Tax (VAT) for using the products and services.";
export var VAT_BLOCK_RDP_BODY = "You have selected a billing country where Remote Desktop products and services are taxable. If your company is registered for VAT, you may not have to pay Value Added Tax (VAT) for using the products and services.";
export var VAT_BLOCK_LABEL = "Enter your Business VAT ID (Optional)";
export var GST_BLOCK_HEADER = "GST Identification Number";
export var GST_BLOCK_BODY = "If your billing country requires taxation for RemotePC products and services, provide your business registration number that indicates your business will be responsible for paying the taxes:";
export var GST_BLOCK_RDP_BODY = "If your billing country requires taxation for Remote Desktop products and services, provide your business registration number that indicates your business will be responsible for paying the taxes:";
export var GST_BLOCK_LABEL = "Enter your GSTIN (Optional)";
export var SELECT_STATE = "Select";
export var DEFAULT_COUNTRY_NAME = "United States of America";
export var POSTAL_CODE = "Postal Code";
export var ZIP_CODE = "Zip Code";
export var STRIPE_PAYMENT_MODE = "stripe";
export var PAYPAL_PAYMENT_MODE = "paypal";
export var GOOGLE_CLIENT_ID = "84723521477-vqmv6hdeqnd7nkq71ouagngabk7mur4k.apps.googleusercontent.com";
export var RDP_GOOGLE_CLIENT_ID = "21186337250-u9tpto27hhkq7isc8ahahp0p019tk244.apps.googleusercontent.com";
export var RDP_ENTERPRISE_CATEGORY = "ENTERPRISE";
export var SOLO_PLAN = "solo";
export var PRO_PLAN = "pro";
export var TEAM_PLAN = "team";
export var ENT_PLAN = "enterprise";
export var SOHO_PLAN = "soho";
export var CONSUMER_PLAN = "consumer";
export var COMPUTER_BASED_PRICING_MODEL = "computer";
export var USER_BASED_PRICING_MODEL = "user";
export var HYBRID_PRICING_MODEL = "hybrid";
export var MINIMUM_COMPANY_NAME_LENGTH = 5;
export var MAXIMUM_COMPANY_NAME_LENGTH = 50;
